import { TerceroService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const TerceroManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const listado = (where) => {
    return TerceroService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const crear = (tercero) => {
    return TerceroService.crear(tercero).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const actualizar = (tercero) => {
    return TerceroService.actualizar(tercero).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const buscarPorId = (id) => {
    return TerceroService.buscarPorId(id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const listarRNCs = (where) => {
    return TerceroService.listarRNCs(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const buscarRNC = (rnc) => {
    return TerceroService.buscarRNC(rnc).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const exportar = (where) => {
    return TerceroService.exportar(where).then((res) => {
      return res;
    });
  };

  return { listado, crear, actualizar, buscarPorId, exportar, listarRNCs, buscarRNC };
})();
